var _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2303 26.3945L10.6167 22.9426L6.64709 30.5482L11.4653 29.3112L13.2606 34.0001L17.2303 26.3945ZM20.089 26.3945L26.7025 22.9426L30.6721 30.5482L25.854 29.3112L24.0586 34.0001L20.089 26.3945Z",
    fill: "#5C1526"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5557 14.7778C31.5557 21.8348 25.8348 27.5557 18.7778 27.5557C11.7208 27.5557 6 21.8348 6 14.7778C6 7.72083 11.7208 2 18.7778 2C25.8348 2 31.5557 7.72083 31.5557 14.7778Z",
    fill: "url(#paint0_linear_306_343)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5557 14.7778C33.5557 22.9394 26.9394 29.5557 18.7778 29.5557C10.6163 29.5557 4 22.9394 4 14.7778C4 6.61626 10.6163 0 18.7778 0C26.9394 0 33.5557 6.61626 33.5557 14.7778ZM18.7778 27.5557C25.8348 27.5557 31.5557 21.8348 31.5557 14.7778C31.5557 7.72083 25.8348 2 18.7778 2C11.7208 2 6 7.72083 6 14.7778C6 21.8348 11.7208 27.5557 18.7778 27.5557Z",
    fill: "#9C6F30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7778 25.5557C24.7303 25.5557 29.5557 20.7303 29.5557 14.7778C29.5557 8.8254 24.7303 4 18.7778 4C12.8254 4 8 8.8254 8 14.7778C8 20.7303 12.8254 25.5557 18.7778 25.5557ZM18.7778 27.5557C25.8348 27.5557 31.5557 21.8348 31.5557 14.7778C31.5557 7.72083 25.8348 2 18.7778 2C11.7208 2 6 7.72083 6 14.7778C6 21.8348 11.7208 27.5557 18.7778 27.5557Z",
    fill: "#F7C580"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2362 9.92212H19.3964V19.6331H17.6212V12.4224H16.7311V11.2873C17.2445 11.2406 17.6045 11.1022 17.8112 10.8722C18.0179 10.6422 18.1596 10.3255 18.2362 9.92212Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_343",
    x1: 18.7778,
    y1: 0,
    x2: 18.7778,
    y2: 29.5557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB012"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.5bdfd033c99d4e807294da9c12b99944.svg";
export { ForwardRef as ReactComponent };